"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadingStateReducer = exports.initialState = void 0;
const types_1 = require("./types");
exports.initialState = {
    loadingState: 0
};
const reducer = (state = exports.initialState, action) => {
    var _a, _b;
    switch (action.type) {
        case types_1.LoadingStateActionTypes.INCREMENT_LOADING_STATE:
            return {
                loadingState: Math.max(((_a = state === null || state === void 0 ? void 0 : state.loadingState) !== null && _a !== void 0 ? _a : 0) + 1, 0)
            };
        case types_1.LoadingStateActionTypes.DECREMENT_LOADING_STATE:
            return {
                loadingState: Math.max(((_b = state === null || state === void 0 ? void 0 : state.loadingState) !== null && _b !== void 0 ? _b : 0) - 1, 0)
            };
        default:
            return state;
    }
};
exports.loadingStateReducer = reducer;
//# sourceMappingURL=reducer.js.map